<template>
  <div class="layout_header_box">
    <div
      :style="{ 'background-color': $store.state.app.themeColor }"
      class="layout_header_cont"
    >
      <RouterDrawe
        :RouterDrawer="drawer"
        @closeCloseDialog="clossuoDialog($event)"
      ></RouterDrawe>

      <div class="flex_center_start_box" style="flex: 1">
        <div id="g74a0d" class="u6c4a8">
          <div @click="drawer = true" class="menu-icon">
            <div class="menu-round-con">
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
            </div>
            <div class="menu-round-con">
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
            </div>
            <div class="menu-round-con">
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
              <div class="menu-round-item"></div>
            </div>
          </div>
        </div>
        <div class="ub36bc flex_center_start_box u5a174">
          <router-link
            id="g92f90"
            class="ub36bc"
            to="/trade/index"
            v-if="$store.state.app.searchType == 'TradeDetail'"
          >
            <img
              class="header_logo"
              src="../../assets/img/logoyanjing.png"
              alt=""
            />
            <span class="logon_pingdao">{{ $t("Home.SearchTrade") }}</span>
          </router-link>
          <router-link
            id="g92f90"
            class="ub36bc"
            to="/dataServices/index"
            v-else-if="$store.state.app.searchType == 'dataServices'"
          >
            <img
              class="header_logo"
              src="../../assets/img/logoyanjing.png"
              alt=""
            />
            <span class="logon_pingdao">{{ $t("Home.DataServices") }}</span>
          </router-link>
          <router-link
            id="g92f90"
            class="ub36bc"
            to="/leads/index"
            v-else-if="$store.state.app.searchType == 'risk'"
          >
            <img
              class="header_logo"
              src="../../assets/img/logoyanjing.png"
              alt=""
            />
            <span class="logon_pingdao">{{ $t("Home.SearchLeads") }}</span>
          </router-link>
          <router-link id="g92f90" class="ub36bc" to="/" v-else>
            <img
              class="header_logo"
              src="../../assets/img/logoyanjing.png"
              alt=""
            />
            <span
              class="logon_pingdao"
              v-if="$store.state.app.searchType == 'company'"
              >{{ $t("Home.SearchCompanies") }}
            </span>
          </router-link>
        </div>
      </div>

      <!-- 贸易    -->
      <div class="topBarBox" v-if="$route.query.Moudles == 'Trade'">
        <div id="g1031d" class="u52ab1">
          <div class="trade-dropdown" @click.stop="isTradeShow = !isTradeShow">
            <span class="select-country-con">
              <span class="select-country-name">{{ selectTradeObj.Name }}</span>
              <i
                class="iconfont icon-jiantouxia"
                :class="{ 'country-arrow': isTradeShow }"
              ></i>
            </span>
          </div>
          <div
            class="trade-popper"
            :class="{ 'trade-show-popper': isTradeShow }"
          >
            <div
              class="trade-item-con"
              v-for="(item, index) in tradeList"
              :key="index"
              :class="{
                activeTrade: selectTradeObj.Code == item.Code,
              }"
              @click="onSelectTrade(item.Code, item.Name)"
            >
              {{ item.Name }}
            </div>
          </div>
          <div id="gcb7b3" class="u6e410 search_left_Trade">
            <el-autocomplete
              id="c308fb"
              class="u0fcfc"
              clearable
              v-model="searchStr"
              style="width: 95%; height: auto"
              :highlight-first-item="true"
              :debounce="300"
              :trigger-on-focus="false"
              :autofocus="true"
              @select="handleSelect"
              :fetch-suggestions="querySearchAsync"
              :placeholder="placeholderTrade"
              size="large"
            >
            </el-autocomplete>
          </div>
          <div id="gfdd55" class="udd32b">
            <svg
              id="c1217c"
              class="icon icon_fangdajing"
              t="1716874034454"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4808"
            >
              <path
                id="c8de55"
                d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                fill="#1A2332"
                p-id="4809"
              ></path>
            </svg>
          </div>
        </div>
      </div>
      <!-- 数据服务-新增 -->
      <div
        class="topBarBox-dataService flex_center_start"
        v-else-if="$route.path.includes('dataServices')"
      >
        <div class="dataService-top">
          <div
            class="dataService-top-link"
            :class="{ active: $route.meta.menuGroup == item.menuGroup }"
            v-for="item in dataServicesList"
            :key="item.title"
            @click="goDataServicePage(item.url)"
          >
            {{ item.title }}
            <div class="active-line"></div>
          </div>
        </div>
        <div class="dataService-input-box flex_center_start">
          <!-- <el-input
            class="dataService-input"
            v-model="dataServicesKeyword"
            placeholder="Enter API name"
            size="large"
            clearable
            @keydown.enter.native="goDataServicePage(null, dataServicesKeyword)"
          >
          </el-input> -->
          <el-cascader
            ref="searchCascader"
            placeholder="Enter API name"
            :options="twoLevelTreeDimension"
            :props="{ emitPath: false }"
            :filter-method="handleCascaderFilter"
            :show-all-levels="false"
            class="dataService-input"
            v-model="dataServicesKeyword"
            filterable
            @change="toApiDetail"
            @visible-change="isApiCascaderVisibleChange"
            popper-class="dataservices-popper dataservices-header-popper"
          ></el-cascader>
          <i
            class="iconfont icon-search search-iconstyle"
            @click="goDataServiceListPage()"
          ></i>
        </div>
      </div>
      <!-- 获客搜索 -->
      <div class="topBarBox" v-else-if="$route.path.includes('/list/risk')">
        <div class="u52ab1">
          <div class="country-dropdown">
            <div
              class="select-country-con"
              @click.stop="leadsIsShowSearchType = !leadsIsShowSearchType"
            >
              <span class="select-country-name">{{ leadsSearchType }}</span>
              <i
                class="iconfont icon-jiantouxia"
                :class="{ open_search: leadsIsShowSearchType }"
              ></i>
            </div>
          </div>
          <div
            class="search_type_select"
            :class="{ search_type_select_show: leadsIsShowSearchType }"
          >
            <div
              class="search_type_select_list"
              :class="{ active: leadsSearchType == lead.title }"
              @click.stop="leadsChoseSearchType(lead)"
              v-for="lead in leadsSelectType"
              :key="lead.index"
            >
              {{ lead.title }}
            </div>
          </div>

          <el-autocomplete
            clearable
            v-model="leadsSearchKeyword"
            style="width: 100%; height: auto"
            :highlight-first-item="true"
            :debounce="300"
            :trigger-on-focus="false"
            :autofocus="true"
            class="search-country-input"
            @select="leadsHandleSelect"
            :fetch-suggestions="leadsQuerySearchAsync"
            :placeholder="leadsPlaceholder"
            size="large"
            value-key="optionsContent"
            v-if="leadsSearchType == 'Product' || leadsSearchType == 'HSCode'"
          >
            <template #default="{ item }">
              <div class="autocomplete-item">
                {{ item.optionsCode }} - {{ item.optionsContent }}
              </div>
            </template>
          </el-autocomplete>

          <el-input
            v-if="leadsSearchType != 'Product' && leadsSearchType != 'HSCode'"
            :disabled="leadsSearchType == 'AI Assistance'"
            v-model="leadsSearchSicKeyword"
            :placeholder="leadsPlaceholder"
            clearable
            size="large"
            style="width: 100%; height: auto"
            class="search-country-input"
            @input="leadsOnInputSic"
          ></el-input>
          <div
            v-if="leadsSearchType != 'Product' && leadsSearchType != 'HSCode'"
            ref="sicRef"
            class="leads_country-popper"
            :class="{
              'leads_country-show-popper':
                leadsIsSicShow &&
                !leadsIsShowSearchType &&
                leadsSearchType != 'AI Assistance',
            }"
          >
            <div class="country-popper-arrow"></div>
            <div class="country-popper-con">
              <div class="leads_state-con">
                <div
                  class="country-state-item"
                  :class="{ leadsActiveState: leadsSelectStateIndex == index }"
                  v-for="(item, index) in leadsProductList"
                  :key="index"
                  @click="leadsOnChangeSic(index)"
                >
                  <span class="leads_country-name">{{
                    item.optionsContent
                  }}</span>
                </div>
              </div>
              <div class="leads_state-country-con">
                <div
                  class="pro_item"
                  v-for="(item, index) in leadsProductList[
                    leadsSelectStateIndex
                  ]?.list"
                  :key="index"
                  @click="
                    leadsHandleSelect(
                      item,
                      leadsProductList[leadsSelectStateIndex].optionsContent,
                    )
                  "
                >
                  {{ item.optionsCode }} - {{ item.optionsContent }}
                </div>
              </div>
            </div>
          </div>

          <div id="g1032d" @click.stop="searhLeads(leadsSearchKeyword)">
            <i class="iconfont icon-search font_bold"></i>
          </div>
        </div>
      </div>
      <!-- 公司搜索 -->
      <div class="topBarBox" v-else>
        <div id="g1031d" class="u52ab1">
          <div
            class="country-dropdown"
            @click.stop="isCountryShow = !isCountryShow"
          >
            <span class="select-country-con">
              <template
                v-if="
                  selectCountryObj.countryCode == null ||
                  selectCountryObj.countryCode == '' ||
                  selectCountryObj.countryCode == 'undefined'
                "
              >
                <span class="country-placeholder">{{
                  $t("Home.selectCountry")
                }}</span>
              </template>
              <template v-else>
                <img
                  :src="selectCountryObj.urlBanner"
                  class="select-country-img"
                />
                <span class="select-country-name">{{
                  selectCountryObj.nameEn
                }}</span>
              </template>
              <i
                class="iconfont icon-jiantouxia"
                :class="{ 'country-arrow': isCountryShow }"
              ></i>
            </span>
          </div>

          <div id="gcb7b3" class="u6e410">
            <el-input
              id="gd0275"
              v-model="searchStr"
              class="u0fcfc"
              :placeholder="$t('MyDatabase.Entercompanyname')"
              size="large"
              clear=""
              @keydown.enter.native="openList(searchStr)"
            >
            </el-input>
          </div>
          <div class="head_swi_keyword">
            <el-switch
              v-model="Keyword"
              :class="routeName == 'riskNoParams' ? 'aaaa' : 'bbbb'"
              @change="switchHeadKeyword"
            ></el-switch>
            <span v-if="Keyword == true" class="switch_txt">{{
              $t("Home.keWord")
            }}</span>
            <span v-else class="switch_txt">{{ $t("Home.firstWord") }}</span>
          </div>

          <div id="gfdd55" class="udd32b" @click="openList(searchStr)">
            <svg
              id="c1217c"
              class="icon icon_fangdajing"
              t="1716874034454"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4808"
            >
              <path
                id="c8de55"
                d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                fill="#1A2332"
                p-id="4809"
              ></path>
            </svg>
          </div>
          <div
            ref="countryRef"
            class="country-popper"
            :class="{ 'country-show-popper': isCountryShow }"
          >
            <div class="country-popper-arrow"></div>
            <div class="country-popper-con">
              <div class="state-con">
                <div
                  class="country-state-item"
                  :class="{ leadsactiveState: selectStateIndex == index }"
                  v-for="(item, index) in stateList"
                  :key="index"
                  @click="onChangeState(index)"
                >
                  <span class="country-name">{{ item.continent.enName }}</span>
                  <span class="country-countryCount">{{
                    item.continent.countryNumStr
                  }}</span>
                </div>
              </div>
              <div class="state-country-con">
                <div
                  class="state-country-item"
                  v-for="(item, index) in stateCountryList"
                  :key="index"
                  :class="{
                    activeCountry:
                      selectCountryObj.countryCode == item.countryCode,
                  }"
                  @click="selectCountryObjFn(item)"
                >
                  <div class="state-country-item-con">
                    <img :src="item.urlBanner" />
                    <div class="state-country-info">
                      <div class="state-country-name">{{ item.nameEn }}</div>
                      <div class="state-country-companyCount">
                        {{ item.companyNumStr }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="gf14a0"
        class="u942df"
        :style="$route.path.includes('dataServices') ? 'margin-left:60px;' : ''"
      >
        <div id="cda00e">
          <div
            class="fontffffff font16 cuspoint textCenter WhatNew"
            v-if="$route.meta.type == 'index' || $route.name == 'home'"
            @click="OpenWhatNew('')"
          >
            What's New?
          </div>
        </div>
        <div id="cda00e" v-if="$store.state.app.OperationWarning">
          <el-popover
            placement="bottom"
            width="200"
            trigger="hover"
            :disabled="!loginStatus"
          >
            <div class="u9qMull">Operation Warning</div>
            <svg
              t="1755585999252"
              @click="OperationWarningShow"
              slot="reference"
              class="icon top_menu_icon icon_ow"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7131"
            >
              <path
                d="M512 179.2l390.4 627.2H128l384-627.2m0-64c-19.2 0-44.8 12.8-51.2 32l-390.4 627.2c-25.6 44.8 6.4 96 51.2 96H896c51.2 0 83.2-57.6 51.2-96l-384-627.2c-6.4-19.2-32-32-51.2-32z"
                fill="#FFC800"
                p-id="7132"
              ></path>
              <path
                d="M512 640c-19.2 0-32-12.8-32-32v-192c0-19.2 12.8-32 32-32s32 12.8 32 32v192c0 19.2-12.8 32-32 32z"
                fill="#FFC800"
                p-id="7133"
              ></path>
              <path
                d="M512 723.2m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
                fill="#FFC800"
                p-id="7134"
              ></path>
            </svg>
          </el-popover>
        </div>
        <div
          v-if="userInfo?.userInfo?.userType == '3'"
          class="top_menu_icon"
          id="header-icon0"
        >
          <el-popover
            :popper-class="popoverListClass"
            placement="bottom"
            trigger="click"
            v-model="isShowGroup"
          >
            <div class="list-popper-con">
              <div
                class="list-popper-con-item"
                :class="{
                  active: item.title == activeGroup,
                }"
                v-for="(item, index) in groupList"
                :key="index"
                @click="onChangeGroup(item.url)"
              >
                <div class="list-popper-con-item-name">{{ item.title }}</div>
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-zuyuan page-top-header-right-icon"
              @click="loginStatus ? '' : gotoUSer('/')"
            ></i>
          </el-popover>
        </div>
        <!-- 超出限制 -->

        <el-badge
          :value="loginStatus ? RedNews.length : ''"
          :hidden="RedNews.length == 0"
          class="item"
        >
          <el-popover
            :popper-class="popoverNewsClass"
            placement="bottom-start"
            trigger="click"
            v-model="isShowNews"
          >
            <div class="news-popper-con">
              <div class="news-popper-con-top">
                <div class="news-popper-con-top-title">
                  <div class="news-popper-con-top-title-txt">
                    {{ $t("navigationBar.Notifications") }}
                  </div>
                  <div
                    class="news-popper-con-top-title-num"
                    v-if="RedNews.length"
                  >
                    {{ RedNews.length }}
                  </div>
                </div>
                <div class="news-popper-con-top-list">
                  <div class="news-popper-con-top-list-con">
                    <div
                      v-for="(item, index) in Newlist"
                      :key="index"
                      @click="gotomessage(item)"
                      class="news-popper-con-top-list-item"
                    >
                      <img
                        class="news-popper-con-top-list-item-logo"
                        src="@/assets/images/newPage/notifyLogo.png"
                        alt=""
                      />
                      <div class="news-popper-con-top-list-item-con">
                        <div class="news-popper-con-top-list-item-title">
                          <div class="news-popper-con-top-list-item-title-txt">
                            {{ item.title }}
                          </div>
                          <div
                            v-show="item.hasRead === 0"
                            class="news-popper-con-top-list-item-title-bg"
                          ></div>
                        </div>
                        <div class="news-popper-con-top-list-item-date">
                          {{ item.createTime }}
                        </div>
                        <div
                          class="news-popper-con-top-list-item-content"
                          v-if="item.content"
                        >
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                    <div v-if="Newlist.length == 0" class="news-popper-con-no">
                      <img :src="noNews" />
                      <span>There is currently no new news</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="news-popper-con-bottom">
                <el-button
                  class="notify-clear-btn"
                  @click="MarkRead()"
                  :disabled="Newlist.length == 0"
                >
                  <i class="iconfont icon-qingchu"></i
                  >{{ $t("navigationBar.MarkasRead") }}
                </el-button>
                <el-button
                  class="notify-view-btn"
                  @click="gotoUSer('/account/notifications')"
                  >{{ $t("navigationBar.Viewall") }}</el-button
                >
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-lingdang222 page-top-header-right-icon icon top_menu_icon"
              @click="loginStatus ? '' : gotoUSer('/')"
            ></i>
          </el-popover>
        </el-badge>

        <el-popover
          :popper-class="popoverPointClass"
          placement="bottom"
          trigger="click"
          v-model="isShowVip"
        >
          <div class="point-popper-con">
            <div
              class="popper-con-user"
              :class="{ golden: lockType == 2, silver: lockType == 1 }"
            >
              <div class="popper-con-user-left">
                <div
                  class="popper-con-user-left-people"
                  :class="{ 'popper-con-user-round': !imageUrl }"
                >
                  <img
                    v-if="imageUrl"
                    class="popper-con-user-left-img"
                    :src="imageUrl"
                    alt=""
                  />
                  <div class="popper-con-user-round-text" v-else>
                    {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
                  </div>
                </div>
                <!-- 金锁 -->
                <img
                  v-if="lockType == 2"
                  class="popper-con-user-left-vip"
                  src="@/assets/images/newPage/goldenVip.png"
                  alt=""
                />
                <!-- 银锁 -->
                <img
                  v-if="lockType == 1"
                  class="popper-con-user-left-vip"
                  src="@/assets/images/newPage/silverVip.png"
                  alt=""
                />
              </div>
              <div class="popper-con-user-right">
                <div class="popper-con-user-right-name">
                  {{ userInfo?.userInfo?.firstName }}
                  {{ userInfo?.userInfo?.lastName }}
                </div>
                <div class="popper-con-user-right-type">
                  <template v-if="lockType == 2">{{
                    $t("navigationBar.GoldSubscriber")
                  }}</template>
                  <template v-if="lockType == 1">{{
                    $t("navigationBar.SilverSubscriber")
                  }}</template>
                  <template v-if="lockType == 0">{{
                    $t("navigationBar.IndivdualAccount")
                  }}</template>
                </div>
              </div>
            </div>
            <div class="point-popper-con-lock">
              <div
                v-for="(item, index) in vipsList"
                :key="index"
                class="point-popper-con-lock-con"
                :class="{
                  'margin-b20': vipsList.length > 1 && item.lockType == 2,
                }"
              >
                <el-progress
                  class="point-popper-con-lock-progress"
                  :percentage="(item.dayUsed / item.totalDays) * 100"
                  :color="item.lockType == 2 ? '#ffa000' : '#999999'"
                  :show-text="false"
                  define-back-color="#dddddd"
                ></el-progress>
                <div
                  class="point-popper-con-lock-desc"
                  v-show="item.lockType == 2"
                >
                  {{ $t("navigationBar.SubscriptionExpires") }} :
                  {{ item.endTime.substring(0, 10) }}
                  <template v-if="!item.isEmpty"
                    >({{ item.dayUsed }}/{{ item.totalDays }})</template
                  >
                </div>
                <div
                  class="point-popper-con-lock-desc"
                  v-show="item.lockType == 1"
                >
                  {{ $t("navigationBar.SubscriptionExpires") }} :{{
                    item.endTime.substring(0, 10)
                  }}
                  <template v-if="!item.isEmpty"
                    >({{ item.dayUsed }}/{{ item.totalDays }})</template
                  >
                </div>
                <!-- <div
                    class="margin-t2 point-popper-con-lock-desc"
                    v-show="
                      vipsList.length > 1 && item.lockType == 1 && !item.isEmpty
                    "
                  >
                    银锁暂停，金锁用完后开启
                  </div> -->
              </div>
            </div>
            <div class="point-popper-con-point">
              <img
                class="point-popper-con-point-icon"
                src="@/assets/images/newPage/point.png"
                alt=""
              />
              <div class="point-popper-con-point-desc">
                {{ $t("navigationBar.AvailableCredits") }}:
                {{ $store.state.app.equityType }}
              </div>
            </div>
            <el-button
              class="credit-btn"
              @click="gotoUSer('/index/addCredit')"
              >{{ $t("navigationBar.AddCredits") }}</el-button
            >
          </div>
          <i
            slot="reference"
            class="iconfont icon-icon-test page-top-header-right-icon icon top_menu_icon"
            @click="loginStatus ? '' : gotoUSer('/')"
          ></i>
        </el-popover>

        <div id="cda00e" class="                   ">
          <el-popover
            :popper-class="popoverListClass"
            placement="bottom"
            trigger="click"
            v-model="isShowLang"
          >
            <div class="list-popper-con">
              <div
                class="list-popper-con-item"
                :class="{
                  active: item.countryCode == $store.state.app.lang,
                  dis: item.disabled,
                }"
                v-for="(item, index) in languageList"
                :key="index"
                @click="selectLanguage(item)"
              >
                <img
                  class="list-popper-con-item-img"
                  :src="
                    require('../../../static' +
                      getCountryImgUrl(item.countryCodeImg))
                  "
                  alt=""
                />
                <div class="list-popper-con-item-name">
                  {{ item.countryName }}
                </div>
              </div>
            </div>
            <i
              slot="reference"
              @click="loginStatus ? '' : gotoUSer('/')"
              class="iconfont icon-yuyan-02 page-top-header-right-icon top_menu_icon"
            ></i>
          </el-popover>
        </div>
        <div id="cda00e" class="                   ">
          <el-popover
            :popper-class="popoverListClass"
            placement="bottom"
            trigger="click"
            v-model="isShowHelp"
          >
            <div class="list-popper-con">
              <div
                class="list-popper-con-item"
                :class="{
                  active: item.title == activeHelp,
                }"
                v-for="(item, index) in helpList"
                :key="index"
                @click="onChangeHelp(item.url)"
              >
                <div class="list-popper-con-item-name">{{ item.title }}</div>
              </div>
            </div>
            <i
              slot="reference"
              class="iconfont icon-wenhao page-top-header-right-icon top_menu_icon"
              @click="loginStatus ? '' : gotoUSer('/')"
            ></i>
          </el-popover>
        </div>

        <div
          id="cda00e"
          :class="
            loginStatus ? 'u1ba31  icon top_menu_icon' : ' icon top_menu_icon'
          "
          @click="loginStatus ? '' : gotoUSer('/')"
        >
          <div
            v-show="loginStatus"
            class="new-header-img page-top-header-item"
            id="header-icon5"
          >
            <el-popover
              :popper-class="popoverPeopleClass"
              placement="bottom"
              trigger="click"
            >
              <div class="people-popper-con">
                <div
                  class="popper-con-user"
                  :class="{ golden: lockType == 2, silver: lockType == 1 }"
                >
                  <div class="popper-con-user-left">
                    <div
                      class="popper-con-user-left-people"
                      :class="{ 'popper-con-user-round': !imageUrl }"
                    >
                      <img
                        v-if="imageUrl"
                        class="popper-con-user-left-img"
                        :src="imageUrl"
                        alt=""
                      />
                      <div class="popper-con-user-round-text" v-else>
                        {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
                      </div>
                    </div>
                    <!-- 金锁 -->
                    <img
                      v-if="lockType == 2"
                      class="popper-con-user-left-vip"
                      src="@/assets/images/newPage/goldenVip.png"
                      alt=""
                    />
                    <!-- 银锁 -->
                    <img
                      v-if="lockType == 1"
                      class="popper-con-user-left-vip"
                      src="@/assets/images/newPage/silverVip.png"
                      alt=""
                    />
                  </div>
                  <div class="popper-con-user-right">
                    <div class="popper-con-user-right-name">
                      {{ userInfo?.userInfo?.firstName }}
                      {{ userInfo?.userInfo?.lastName }}
                    </div>

                    <div
                      class="popper-con-user-right-type"
                      v-if="userInfo?.userInfo?.userType == '1'"
                    >
                      {{ $t("navigationBar.IndivdualAccount") }}
                    </div>
                    <div class="popper-con-user-right-type" v-else>
                      {{ $t("navigationBar.GroupAccount") }}
                    </div>
                  </div>
                </div>
                <div class="people-popper-con-line"></div>
                <div class="list-popper-con">
                  <div
                    class="list-popper-con-item"
                    v-for="(item, index) in peopleList"
                    :key="index"
                    @click="onChangePople(item.url)"
                  >
                    <i class="iconfont" :class="item.icon"></i>{{ item.title }}
                  </div>
                </div>
                <div class="people-popper-con-line"></div>
                <div class="people-popper-con-signout">
                  <div class="list-popper-con-item" @click="onLogOut">
                    <i class="iconfont icon-tuichu"></i
                    >{{ $t("MyAccount.SignOut") }}
                  </div>
                </div>
              </div>

              <div
                slot="reference"
                class="page-top-header-right-people"
                :class="{ 'popper-con-user-round': !imageUrl }"
              >
                <img
                  v-if="imageUrl"
                  :src="imageUrl"
                  alt=""
                  class="page-top-header-right-img"
                />
                <div class="popper-con-user-round-text" v-else>
                  {{ userInfo?.userInfo?.firstName.substring(0, 1) }}
                </div>
              </div>
            </el-popover>
          </div>
          <!-- 未登录 -->
          <div
            v-show="!loginStatus"
            class="page-top-header-right-login"
            @click="onLogin"
          >
            <div>Sign in</div>
            <i class="iconfont icon-wode"></i>
          </div>
        </div>
        <div id="g87c30" @click="AIseach()" class="u6f58a">
          <img
            id="g61a71"
            class="u81734"
            src="../../assets/images/chart2.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <OperationWarning></OperationWarning>
  </div>
  <!--srcviewslayoutheadervuehtmlEnd-->
</template>

<script>
import { mixins1 } from "@/mixins/index";
import {
  getCountryCollection,
  getUserSimpleInfo,
  getLeadsHomeProList,
  getSicIndustryCode,
  getHsSearch,
} from "@/api/companyApi.js";
import { LoginOut } from "@/api/api.js";
import bus from "../../components/bus";
import {
  getNotificationList,
  markAllAsRead,
  companyView,
} from "@/api/userApi.js";
import {
  searchCompany,
  productSearch,
  searchTradeHscode,
} from "@/api/searchApi.js";
import RouterDrawe from "../../components/router-drawer/drawer.vue";
import OperationWarning from "../../components/power/OperationWarning.vue";
import { mapGetters } from "vuex";
import { getApiCatalogueTree } from "@/api/dataServicesApi";
import { debounce } from "lodash";

export default {
  mixins: [mixins1],
  name: "",
  props: {},
  components: {
    RouterDrawe,
    OperationWarning,
  },
  computed: {
    ...mapGetters({
      lang: "app/lang",
    }),
    popoverListClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper list-popper home-popper"
        : "header-popper list-popper";
    },
    popoverNewsClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper news-popper home-popper"
        : "header-popper news-popper";
    },
    popoverPointClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper point-popper home-popper"
        : "header-popper point-popper";
    },
    popoverPeopleClass() {
      return this.currentObj.type == "index" || this.$route.name == "home"
        ? "header-popper people-popper home-popper"
        : "header-popper people-popper";
    },
    // ✅ 只取前两层
    twoLevelTreeDimension() {
      return this.treeDimension.map((level1) => {
        if (level1.children) {
          // 保留 label 和 value
          const level2WithoutChildren = level1.children.map((level2) => {
            return {
              value: level2.id,
              label: level2.name,
            };
          });
          return {
            value: `root-${level1.id}`, // 生成父节点的唯一 ID (例如: "root-1") 防止与子级id重复 选中时页面不回显问题
            label: level1.name,
            children: level2WithoutChildren,
          };
        }
        return level1;
      });
    },
  },

  created() {
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    bus.$on("handleLogin", (loginCheck) => {
      this.loginStatus = loginCheck;
      this.$router.go(0);
    });
    if (this.token) {
      this.companyViewPower();

      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfoImg")) == undefined
          ? this.imageUrl
          : JSON.parse(localStorage.getItem("userInfoImg"));
      this.getUserSimpleInfoList();
    }
    this.getCountryList();
  },

  mounted() {
    if (this.$route.params.search) {
      this.searchStr = this.$route.params.search;
    }
    // 页面跳转头部搜索框值回显（手动输入的字）
    if (this.$route.query && this.$route.query.keyword) {
      let inputEl = this.$refs.searchCascader.$el.querySelector("input");
      inputEl.value = this.$route.query.keyword; //输入框里的文字
    }
    // 页面跳转头部搜索框值回显（点击获取的id）
    if (this.$route.query && this.$route.query.id) {
      this.dataServicesKeyword = this.$route.query.id;
    }
    this.selectLanguage({ countryCode: this.$store.state.app.lang });
    this.$i18n.locale = this.$store.state.app.lang;
    this.$store.dispatch("app/setLang", this.$i18n.locale);
    this.getCountryList();
    document.addEventListener("click", this.handleClickOutside);
    if (this.$route.name == "sanctionIndex") {
      document.title = "Search Sanctions";
    } else if (
      this.$route.path.includes("sanction") &&
      this.$route.path.includes("List")
    ) {
      document.title = "Search Sanctions List";
    } else if (this.$route.name == "newsIndex") {
      document.title = "Search News";
    } else if (
      this.$route.path.includes("news") &&
      this.$route.path.includes("list")
    ) {
      document.title = "Search News List";
    } else if (this.$route.name == "uboIndex") {
      document.title = "Search Relationship";
    } else if (
      this.$route.path.includes("ubo") &&
      this.$route.path.includes("list")
    ) {
      document.title = "Search Relationship List";
    } else if (this.$route.name == "leadsIndex") {
      document.title = "Search Leads";
    } else if (this.$route.path.includes("index/list/risk")) {
      document.title = "Search Leads List";
    } else if (this.$route.name == "tradeIndex") {
      document.title = "Search Trade";
    } else if (this.$route.path.includes("riskScanning")) {
      document.title = "Risk Scan";
    } else if (this.$route.path.includes("index/search/list")) {
      document.title = "Search Company List";
    } else if (this.$route.path.includes("account")) {
      document.title = "My Account";
    }
    this.getApiCatalogueTreeFn(); //调一次存起来
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  watch: {
    "$store.state.app.NotificationsList": {
      handler(newVal, oldVal) {
        this.Newlist = [];
        this.RedNews = [];
        if (this.token) {
          this.getNotificationListDetali();
        }
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },

    "$store.state.app.labelCode": {
      handler(newVal, oldVal) {
        if (newVal != "") {
          this.searchStr = "";
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    "$route.name": {
      handler(newVal, oldVal) {
        this.routeName = newVal;
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    $route(to, from) {
      this.currentObj = to.meta;
    },
  },
  data() {
    return {
      treeDimension: [],
      isApiDropdownShow: false,
      Newlist: [],
      noNews: require("@/assets/images/newPage/noNews.png"),
      AvailablePoints: 0,
      percentage: 0,
      percentagejin: 0,
      routeName: "companylistSearch",
      ExpireDate: "",
      Keyword:
        this.$route.query.keword == 2 || this.$route.query.keword == undefined
          ? true
          : false,
      drawer: false,
      selectName: "Personal",
      searchStr: "",
      selectValue: "Keywork",
      tradeSelect: "HsCode",
      placeholderTrade: "Search by",
      currentObj: {},
      isShowVip: false,
      isShowLang: false,
      isTradeShow: false,
      isCountryShow: false,
      selectStateIndex: 0,
      selectCountryObj: {
        countryCode: "",
      },
      stateList: [],
      stateCountryList: [],
      stateCountryListCopy: [],
      selectTradeObj: {
        Code: "HsCode",
        Name: "Product",
      },
      tradeList: [
        {
          Code: "HsCode",
          Name: "Product",
        },
        {
          Code: "Company",
          Name: "Company",
        },
        {
          Code: "Country",
          Name: "Country",
        },
      ],
      activeLang: "English",
      vipsList: [],
      languageList: [
        {
          countryCode: "en",
          countryCodeImg: "GB",
          countryName: "English",
        },
        {
          countryCode: "jp",
          countryCodeImg: "JP",
          countryName: "Japanese",
        },
        {
          countryCode: "de",
          countryCodeImg: "DE",
          countryName: "German",
        },
        {
          countryCode: "fr",
          countryCodeImg: "FR",
          countryName: "France",
        },
        {
          countryCode: "es",
          countryCodeImg: "ES",
          countryName: "Spain",
        },
        {
          countryCode: "it",
          countryCodeImg: "IT",
          countryName: "Italy",
        },
        {
          countryCode: "nl",
          countryCodeImg: "NL",
          countryName: "Netherlands",
        },
        {
          countryCode: "pt",
          countryCodeImg: "PT",
          countryName: "Portugal",
        },
      ],
      isShowGroup: false,
      isShowHelp: false,
      isShowNews: false,
      activeGroup: "",
      activeHelp: "",
      helpList: [
        {
          title: this.$t("AccountCenterMenu.FAQ"),
          url: "/account/fAQ",
        },
        {
          title: this.$t("AccountCenterMenu.Privacy"),
          url: "/account/privacyPolicy",
        },
        {
          title: this.$t("AccountCenterMenu.Terms"),
          url: "/account/terms",
        },
        {
          title: this.$t("AccountCenterMenu.ReportIssues"),
          url: "/account/reportaproblem",
        },
        {
          title: this.$t("AccountCenterMenu.UserGuide"),
          url: "/account/instructions",
        },
        {
          title: this.$t("AccountCenterMenu.AboutCSI"),
          url: "/account/About",
        },
      ],
      groupList: [
        {
          title: this.$t("navigationBar.GroupAccount"),
          url: "/account/userGroup",
        },
        {
          title: this.$t("navigationBar.UserAccount"),
          url: "/account/user",
        },
        {
          title: this.$t("navigationBar.Roles"),
          url: "/account/roles",
        },
      ],
      // handleQueryloading
      handleQueryloading: false,
      headPortrait: false,
      countryCode: "",
      countryCode1: "",
      tabCountryList: [],
      RedNews: [],
      countryName: "", //选中国家
      tabActiveName: "", //选择的区域
      isNotice: true, //通知高亮
      loginStatus: false,
      lockType: 0,
      token: localStorage.getItem("token"),
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,
      // 数据服务跳转
      dataServicesKeyword: "",
      dataServicesList: [
        {
          title: "Data Cleaning",
          name: "dataCleaning",
          url: "/dataServices/dataCleaning",
          menuGroup: "dataCleaning",
        },
        {
          title: "Data API",
          name: "APIHomepage",
          url: "/dataServices/dataApi",
          menuGroup: "dataApi",
        },
        {
          title: "Bulk Data",
          name: "bulkData",
          url: "/dataServices/bulkData",
          menuGroup: "bulkData",
        },
        {
          title: "Data Library",
          name: "dataLibrary",
          url: "/dataServices/dataLibrary",
          menuGroup: "dataLibrary",
        },
        {
          title: "Customize Your Own Plan",
          name: "customizePlan",
          url: "/dataServices/customizePlan",
          menuGroup: "customizePlan",
        },
      ],
      peopleList: [
        {
          icon: "icon-wode",
          title: "Account",
          url: "/account/myAccount",
        },
        {
          icon: "icon-shujuku-hover",
          title: "My Database",
          url: "/account/companiesViewed?type=1",
        },
        {
          icon: "icon-icon-test",
          title: "Billing and Payment",
          url: "/account/billRecord",
        },
        {
          icon: "icon-shezhi",
          title: "User Settings",
          url: "/account/UserSettings",
        },
        {
          icon: "icon-lingdang",
          title: "Messages",
          url: "/account/notifications",
        },
      ],
      //获客搜索
      leadsIsSicShow: false,
      leadsSearchType: "Product",
      leadsSearchKeyword: "",
      leadsSearchSicKeyword: "",
      leadsIsShowSearchType: false,
      leadsSelectStateIndex: 0,
      leadsTextList: [
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
        {
          title: "Business Intelligence",
        },
        {
          title: "Company Identity Verification",
        },
        {
          title: "KYC Solutions",
        },
        {
          title: "Company Financial Analysis",
        },
        {
          title: "Credit Ratings",
        },
        {
          title: "Credit Reports",
        },
        {
          title: "ESG Ratings",
        },
        {
          title: "Vendor Screening",
        },
        {
          title: "Market Research",
        },
        {
          title: "Industry Analysis",
        },
        {
          title: "Business Analytics",
        },
        {
          title: "Import-Export Data",
        },
        {
          title: "Company News",
        },
        {
          title: "Sanctions",
        },
        {
          title: "Search Leads",
        },
      ],

      leadsSelectType: [
        {
          id: 1,
          title: "Product",
        },
        {
          id: 2,
          title: "SIC - Standard Industry Code",
        },
        {
          id: 3,
          title: "HSCode - Harmonized System Code",
        },
        // {
        //   id: 4,
        //   title: "GPC - Global Product Classification",
        // },
        {
          id: 5,
          title: "AI Assistance",
        },
      ],
      leadsPlaceholder: "Enter Product Name",
      leadsProductList: [],
      leadsOptionsCode: "",
    };
  },
  methods: {
    // 搜索框重级联选择选中 跳转e二级api详情页
    toApiDetail(id) {
      this.$router.push({
        name: "APIHomepage_more_detail",
        query: { id: id },
      });
    },
    // 下拉框展示隐藏
    isApiCascaderVisibleChange(val) {
      this.isApiDropdownShow = val;
      if (!val) return;
      // 默认显示第一级的子级
      // 1. 获取下拉框面板元素 (使用你定义的 popper-class)
      const popper = document.querySelector(".dataservices-header-popper");
      if (!popper) return;

      // 2. 找到第一级的菜单列表
      // Element UI 的结构通常是：.el-cascader-menu (第一列) -> .el-cascader-node
      const firstMenu = popper.querySelector(".el-cascader-menu");
      if (!firstMenu) return;

      // 3. 找到第一级的第一个节点 (或者你可以遍历所有节点)
      const firstNode = firstMenu.querySelector(".el-cascader-node");

      if (firstNode) {
        // 4. 【关键】模拟鼠标移入事件，触发子级显示
        // 注意：必须使用 'mouseenter' 或 'mouseover'，且 bubbles: true
        const event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
        });
        firstNode.dispatchEvent(event);
      }
      const input = this.$refs.searchCascader?.$el.querySelector("input");
      if (input) input.focus();

      // if (!val) {
      //   // 当组件试图关闭时
      //   // 1. 清除之前的关闭定时器
      //   if (this.closeTimer) clearTimeout(this.closeTimer);

      //   // 2. 设置延迟关闭
      //   this.closeTimer = setTimeout(() => {

      //   }, 600);
      // } else {
      //   // 当组件打开时，清除关闭定时器
      //   if (this.closeTimer) clearTimeout(thisTimer);
      // }
    },
    // 自定义搜索：支持搜任意层级的 label
    handleCascaderFilter(node, keyword) {
      if (!keyword || !node?.label) return false;

      try {
        const fullPath = this.getNodePathLabel(node);
        return fullPath.toLowerCase().includes(keyword.toLowerCase());
      } catch (e) {
        console.warn("Search error:", e);
        return node.label.toLowerCase().includes(keyword.toLowerCase());
      }
    },
    // 获取节点的完整路径 label，如 "亚洲 / 中国"
    getNodePathLabel(node) {
      let path = [node.label];
      let parent = node.parent;
      while (parent && parent.label) {
        path.unshift(parent.label);
        parent = parent.parent;
      }
      // console.log("path", path);
      return path.join(" / ");
    },
    // api 1 2 3级数据
    async getApiCatalogueTreeFn() {
      let arrData = localStorage.getItem("ApiCatalogueTreeData");
      if (arrData) {
        this.treeDimension = JSON.parse(
          localStorage.getItem("ApiCatalogueTreeData"),
        );
        console.log("获取树形结构DataDimension", this.treeDimension);
        return;
      }
      await getApiCatalogueTree().then((res) => {
        console.log("获取树形结构DataDimension", res);
        if (res.code == 200 && res.data.length > 0) {
          this.treeDimension = res.data;
          localStorage.setItem(
            "ApiCatalogueTreeData",
            JSON.stringify(res.data),
          );
        }
      });
    },

    handleClickOutside(event) {
      let countryRef = this.$refs.countryRef;
      if (countryRef && !countryRef.contains(event.target)) {
        this.isCountryShow = false;
      }
    },
    OpenWhatNew() {
      let routeData = this.$router.resolve({
        path: "/whatIsNew",
      });

      window.open(routeData.href, "_blank");
    },
    // 手动输入搜索跳转到list页面
    goDataServiceListPage() {
      let inputEl = this.$refs.searchCascader.$el.querySelector("input");
      let manualInput = inputEl ? inputEl.value : ""; //输入框里的文字
      if (manualInput) {
        this.$router.push({
          path: "/dataServices/list",
          query: {
            keyword: manualInput,
          },
        });
      }
    },
    goDataServicePage(path) {
      this.$router.push({ path: path });
    },
    selectLanguage(item) {
      this.$i18n.locale = item.countryCode;
      sessionStorage.setItem("language", this.$i18n.locale);
      this.$store.dispatch("app/setLang", this.$i18n.locale);
    },
    companyViewPower() {
      companyView({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (!res.data) {
          this.$store.dispatch("app/SetOperationWarning", true);
        }
      });
    },
    OperationWarningShow() {
      this.$bus.$emit("show-OperationWaring-dialog", "");
    },
    onLogin() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$parent.loginDialog = true;
      }
    },
    onLogOut() {
      LoginOut({}).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          bus.$off("handleLogin");
          location.reload();
          // this.$router.push({ path: "/" });
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
        }
      });
    },
    onChangePople(url) {
      if (this.loginStatus) {
        this.$router.push({
          path: url,
        });
      } else {
        this.$parent.loginDialog = true;
      }
    },
    onChangeGroup(url) {
      this.isShowGroup = false;
      if (this.loginStatus) {
        this.$router.push({
          path: url,
        });
      } else {
        this.$parent.loginDialog = true;
      }
    },
    onChangeHelp(url) {
      this.isShowHelp = false;
      if (this.loginStatus) {
        if (url == "/account/reportaproblem" && this.lockType == 0) {
          this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
        } else if (url == "/account/instructions" && this.lockType == 2) {
          this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
        } else {
          this.$router.push({
            path: url,
          });
        }
      } else {
        this.$parent.loginDialog = true;
      }
    },
    switchHeadKeyword() {},
    // 选择贸易频道
    onSelectTrade(code, name) {
      this.searchStr = "";
      this.tradeSelect = code;
      this.selectTradeObj.Code = code;
      this.selectTradeObj.Name = name;
      this.isTradeShow = false;
    },
    //贸易搜索下拉
    handleSelect(item) {
      let SACode1 = "";
      if (this.tradeSelect == "Company") {
        this.searchStr = "";
        sessionStorage.setItem("company", JSON.stringify(item));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
          .countryList;

        newscountry.map((ite) => {
          if (ite.countryCode == item.company_country) {
            SACode1 = ite.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          path:
            "/index/tradeCompany/Trade/" +
            item.aaa_id +
            "/tradeMap/map?id3a=" +
            item.aaa_id +
            "&companyCountry=" +
            item.company_country +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            item.company_name_en +
            "&Tradechannel=" +
            this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
        this.searchStr = "";
      }
      if (this.tradeSelect == "HsCode") {
        this.searchStr = "";
        let routeData = this.$router.resolve({
          path:
            "/index/TradeProduct/TradeDetail/" +
            item.hsCode +
            "/tradeMap/map?id3a=" +
            item.hsCode +
            "&Tradechannel=" +
            this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
      if (this.tradeSelect == "Country") {
        this.searchStr = "";
        let routeData = this.$router.resolve({
          path:
            "/index/TradeCountry/TradeDetail/" +
            item.countryCode +
            "/tradeMap/map?id3a=" +
            item.countryCode +
            "&Tradechannel=" +
            this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
    },
    // 贸易模糊搜索
    querySearchAsync(queryString, cb) {
      if (queryString !== "") {
        if (this.tradeSelect == "HsCode") {
          const params = {
            keyword: queryString,
          };
          productSearch(params)
            .then((res) => {
              const data = res.data;
              if (res.code) {
                data.forEach((item) => {
                  item.val = item.hsCode;
                  item.value = item.hsCode + "-" + item.hsCodeDescription;
                });

                cb(data);
              } else {
                cb([]);
              }
            })
            .catch(() => {
              cb([]);
            });
        }
        if (this.tradeSelect == "Company") {
          const params = {
            company_name: queryString,
            page: 1,
            pageSize: 99,
            ieflag: 1,
          };
          searchCompany(params)
            .then((res) => {
              const data = res.data;
              if (res.code) {
                data.rows.forEach((item) => {
                  item.val = item.aaa_id;
                  item.value = item.company_name_en;
                });
                cb(data.rows);
              } else {
                cb([]);
              }
            })
            .catch(() => {
              cb([]);
            });
        }
        if (this.tradeSelect == "Country") {
          let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0]
            .countryList;
          Allcountry.forEach((item) => {
            item.value = item.nameEn;
            item.val = item.countryCode;
          });
          let SelecrCountry = queryString
            ? Allcountry.filter(this.createStateFilter(queryString))
            : Allcountry;
          cb(SelecrCountry);
        }
      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    AIseach() {
      if (this.lockType == 2 || this.lockType == 3) {
        this.$emit("select", "ai");
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    gotoOne(value) {
      window.open(value, "_blank");
    },
    clossuoDialog(value) {
      this.drawer = value;
    },
    getUserSimpleInfoList() {
      getUserSimpleInfo().then((res) => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem("renzheng", true);
          }
          if (res.data.vips.length == 0) {
            res.data.vips = [
              {
                dayUsed: 0,
                startTime: "",
                endTime: "",
                lockType: 2,
                isEmpty: true,
                totalDays: 1,
              },
              {
                dayUsed: 0,
                startTime: "",
                endTime: "",
                lockType: 1,
                isEmpty: true,
                totalDays: 1,
              },
            ];
          }
          this.vipsList = res.data.vips;
          this.lockType = res.data.lockType;
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);
        }
      });
    },
    MarkRead() {
      markAllAsRead().then((res) => {
        if (res.code == 200) {
          this.getNotificationListDetali();
          this.RedNews.length = 0;
        }
      });
    },

    getNotificationListDetali() {
      getNotificationList().then((res) => {
        if (res.code == 200) {
          this.Newlist = res.data;
          if (this.Newlist.length > 0) {
            res.data.map((item) => {
              if (item.hasRead == 0) {
                this.RedNews.push(item);
              }
            });
          }
        } else {
          this.Newlist = [];
        }
      });
    },
    gotomessage(item) {
      this.$router.push({
        path: "/account/notifications",
        query: {
          id: item.id,
          keword: this.$route.query.keword,
        },
      });
    },
    //下拉选择国家
    gotoUSer(route) {
      if (route == "/") {
        this.$parent.loginDialog = true;
      } else {
        this.$router.push({
          path: route,
          query: {
            keword: this.$route.query.keword,
          },
        });
      }
    },
    //   获取国家列表
    async getCountryList() {
      if (localStorage.getItem("countryList")) {
        this.setCountryImg();
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
      } else {
        let res = await getCountryCollection();
        if (res && res.code) {
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          );
          localStorage.setItem("countryList", JSON.stringify(res.data.rows));

          this.setCountryImg();
          this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        }
      }
    },
    //   设置国家图片
    setCountryImg() {
      this.stateList = JSON.parse(localStorage.getItem("countryList"));
      this.stateList.map((item) => {
        item.countryList.map((itemC) => {
          if (itemC.urlBanner == null) {
            itemC.urlBanner = require("../../../static/imagev2/zanwutupian.png");
          } else {
            let getImageUrlPath = itemC.urlBanner.split("/static")[1];
            itemC.urlBanner = require("../../../static" + getImageUrlPath);
          }
        });
      });

      this.stateCountryList = this.stateList[0].countryList;
      // 信息参数不为空时赋值
      if (
        this.countryCode != "" &&
        this.countryCode != null &&
        this.countryCode != "undefined"
      ) {
        if (this.$route.meta.title == "NewsList") {
          this.selectCountryObj = this.stateCountryList.filter(
            (item) => item.countryCode == this.countryCode,
          )[0];
        } else {
          let filterData = this.sanctionList.filter(
            (item) => item.dictDataCode == this.countryCode,
          )[0];
          this.selectSanctionObj = {
            sanctionCode: filterData.dictDataCode,
            sanctionName: filterData.dictDataName,
          };
        }
      }
    },
    // 切换州
    onChangeState(index) {
      this.selectStateIndex = index;
      this.stateCountryList = this.stateList[index].countryList;
    },
    // 选择国家
    selectCountryObjFn(ite) {
      this.selectCountryObj = ite;
      this.countryCode = ite.countryCode;
      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == ite.countryCode) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
      this.isCountryShow = false;
    },
    signOutAccount() {
      LoginOut({}).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          bus.$off("handleLogin");
          location.reload();
          // this.$router.replace({ path: "/" });
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
        }
      });
    },
    labelClick(label) {
      this.countryName = label;
    },
    openList(str) {
      this.$store.dispatch("app/SetlabelCode", "");
      this.$store.dispatch("app/SetlabelCodeName", "");
      this.$store.dispatch("app/SetarchagAin", true);
      if (str) {
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + str + "/company",
          query: {
            searchname: str,
            companyCountry: this.countryCode,
            keword: this.Keyword ? 2 : 1,
            companyCountryEn: this.countryCode1,
          },
        });
      }
    },
    async getProductToplist() {
      let data = await findWhereCarouseProduct({
        startTime: "",
        endTime: "",
        start: 0,
        limit: 10000,
        name: queryParams.value.name,
        introduction: "",
        thumbnail: "",
        largeImage: "",
        content: "",
        productId: "",
      });

      if (data) {
      } else {
      }
    }, // openUrl
    openUrl(pathUrl) {
      let routeData = this.$router.resolve({
        path: pathUrl + "?keword=" + this.$route.query.keword,
      });
      window.open(routeData.href, "_blank");
      this.drawer = false;
    }, // changeName
    changeName(value) {
      this.selectName = value;
    }, // handleQuery
    openAi() {},

    //获客搜索
    //级联下拉
    leadsOnChangeSic(index) {
      this.selectStateIndex = index;
    },
    // 输入框输入事件
    leadsOnInputSic: debounce(function (val) {
      if (val) {
        getSicIndustryCode({
          optionsContent: val,
        }).then((res) => {
          if (res.code == 200) {
            const restaurants = res.data || [];
            // 过滤结果，支持模糊查询optionsCode或optionsContent
            const filteredResults = restaurants
              .map((category) => ({
                ...category,
                list: category.list.filter((item) => {
                  const lowercaseVal = val.toLowerCase();
                  const itemCode = (item.optionsCode || "").toLowerCase();
                  const itemContent = (item.optionsContent || "").toLowerCase();
                  return (
                    itemCode.indexOf(lowercaseVal) !== -1 ||
                    itemContent.indexOf(lowercaseVal) !== -1
                  );
                }),
              }))
              .filter((category) => category.list.length > 0);

            this.leadsProductList = filteredResults;
            // 只有当过滤结果有内容时，才显示下拉框
            this.leadsIsSicShow = filteredResults.length > 0;
          }
        });
      } else {
        this.leadsIsSicShow = false;
      }
    }, 500),

    leadsQuerySearchAsync(queryString, cb) {
      const token = localStorage.getItem("token");
      if (token) {
        if (queryString !== "") {
          if (this.leadsSearchType == "Product") {
            getLeadsHomeProList({
              pageSize: 100,
              productNameDesc: queryString,
            }).then((res) => {
              if (res.code == 200) {
                const restaurants = res.data || []; // 确保res.data是数组
                const results = queryString
                  ? restaurants.filter(this.leadsCreateFilter(queryString))
                  : restaurants;
                cb(results);
              }
            });
          } else if (this.leadsSearchType == "HSCode") {
            getHsSearch({
              optionsContent: queryString,
            }).then((res) => {
              if (res.code == 200) {
                const restaurants = res.data || []; // 确保res.data是数组
                const results = queryString
                  ? restaurants.filter(this.leadsCreateFilter(queryString))
                  : restaurants;
                cb(results);
              }
            });
          }
        }
      } else {
        this.loginDialog = true;
        cb([]);
      }
    },

    leadsCreateFilter(queryString) {
      const lowercaseQuery = queryString.toLowerCase();
      return (restaurant) => {
        const optionsCode = (restaurant.optionsCode || "").toLowerCase();
        const optionsContent = (restaurant.optionsContent || "").toLowerCase();
        return (
          optionsCode.indexOf(lowercaseQuery) !== -1 ||
          optionsContent.indexOf(lowercaseQuery) !== -1
        );
      };
    },

    leadsChoseSearchType(item) {
      this.leadsSearchType = item.title;
      this.leadsIsShowSearchType = false;
      this.$refs.leadsSearchTypeRef;
      this.leadsSearchSicKeyword = "";
      this.leadsSearchKeyword = "";
      if (item.id == 1) {
        this.leadsPlaceholder = "Enter Product Name";
        this.leadsSearchType = "Product";
        this.leadsQuerySearchAsync(this.leadsSearchKeyword, (results) => {}); //product
      } else if (item.id == 2) {
        this.leadsPlaceholder =
          " Enter ISIC / NACE / NAICS / CSIC / AAAIC / GICS";
        this.leadsSearchType = "SIC";
        this.leadsOnInputSic(this.leadsSearchSicKeyword); //sic
      } else if (item.id == 3) {
        this.leadsPlaceholder = "Enter Harmonized System Code";
        this.leadsSearchType = "HSCode";
        this.leadsQuerySearchAsync(this.leadsSearchKeyword, (results) => {}); //hs
      } else if (item.id == 4) {
        this.leadsPlaceholder = "Enter Global Product Classification";
      } else if (item.id == 5) {
        this.leadsPlaceholder = "";
        const token = localStorage.getItem("token");
        if (token) {
          this.$router.push({
            path: "/index/list/risk",
            query: {
              keyword: "",
              selectCode: 4,
            },
          });
        } else {
          this.loginDialog = true;
        }
      }
    },

    leadsHandleSelect(item, optionsType) {
      this.leadsOptionsCode = item.optionsContent;
      if (this.leadsSearchType == "Product") {
        this.$router.push({
          path: "/index/list/risk",
          query: {
            keyword: item.optionsCode,
            selectCode: 1,
          },
        });
      } else if (this.leadsSearchType == "SIC") {
        this.leadsIsSicShow = false;
        this.leadsSearchSicKeyword =
          item.optionsCode + " - " + item.optionsContent;
        this.$router.push({
          path: "/index/list/risk",
          query: {
            optionsType: optionsType,
            keyword: item.optionsCode,
            selectCode: 2,
          },
        });
      } else if (this.leadsSearchType == "HSCode") {
        this.$router.push({
          path: "/index/list/risk",
          query: {
            keyword: item.optionsCode,
            selectCode: 3,
          },
        });
      } else {
        this.$router.push({
          path: "/index/list/risk",
          query: {
            keyword: "",
            selectCode: 4,
          },
        });
      }
    },
    // 检索
    searhLeads(val) {
      const token = localStorage.getItem("token");
      if (token) {
        if (this.leadsSearchKeyword == "" || this.leadsSearchKeyword == null) {
          this.$message({
            message: this.leadsPlaceholder,
            center: true,
            type: "error",
          });
          return;
        }
        this.leadsHandleSelect({ optionsContent: val }, "");
      } else {
        this.loginDialog = true;
      }
    },
  },
};
</script>
<style scoped>
.layout_header_box {
  height: 100%;
}
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.layout_header_cont {
  display: flex;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  justify-content: space-between;
  position: relative;
  padding: 0 40px 0 30px;
}

.u6c4a8 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0rem;
  padding-bottom: 0rem;
  padding-right: 0rem;
}

.u5a174 {
  display: flex;
  align-items: center;
  height: 28px;
  width: 270px;
}
.dataServices-theme .u5a174 {
  width: 180px !important;
}
.ub36bc {
  display: flex;
  align-items: center;
  height: 28px;
}
.u96216 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  opacity: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.21);
  margin-right: 1.428rem;
}

.u51469 {
  display: flex;
}

.uVRU8uU {
  margin-right: 0.5rem;
  fill: #fff;
}

.uef8b8 {
  width: 5rem;
  font-size: 1.1428575rem;
}

.topBarBox {
  width: 50.28571428571429rem;
  height: 3.857rem;
}
.u52ab1 {
  display: flex;
  align-items: center;
  background-color: rgb(255, 255, 255);
  box-sizing: border-box;
  width: 700px;
  height: 54px;
  padding: 12px 20px 12px 0px;
  border-radius: 27px;
  margin-right: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 17px;
  margin: auto;
}

.uTh6lQG {
  display: flex;
  align-items: center;
  height: 3rem;
}

.ua2717 {
  display: flex;
  align-items: center;
  height: 2.5rem;
  box-sizing: border-box;
}

.uihjfMt {
  color: #1a2332;
  margin-right: 1.0714285714285714rem;
  font-size: 1rem;
}

.ucff1d {
  display: flex;
  box-sizing: border-box;
  padding-left: 0.1rem;
  padding-top: 0.1rem;
  padding-right: 0.1rem;
  padding-bottom: 0.1rem;
  border-style: dashed;
  border-color: #9b9b9b;
  border-width: 0.07142857142857142rem;
}

.u0eb4b {
  height: 2.142rem;
}

.uc6fcf {
  display: flex;
  margin-right: 0.5rem;
  flex: auto;
  font-size: 1rem;
  flex-wrap: wrap;
  width: 6.714285714285714rem;
}

.uiZXktJ {
  margin-right: 0.5rem;
}

.u4229a {
  height: 2.142857142857143rem;
  margin-right: 0.5rem;
  border-right-style: solid;
  border-right-width: 0.07142857142857142rem;
  border-right-color: #dddddd;
}

.u6e410 {
  position: relative;
  width: 45%;
  flex: auto;
  margin-right: 10px;
}

.u0fcfc {
  width: 90%;
  height: 30px;
  line-height: 30px !important;
  flex: none;
  outline: none;
  border: none;
  box-shadow: none;
  font-size: 16px;
}

.u0fcfc /deep/ .el-input__inner {
  width: 100%;
  height: 30px;
  line-height: 30px !important;
  font-size: 16px !important;
}
.u0fcfc /deep/ .el-input__inner::placeholder {
  color: #8497ab;
}

.u812f9 {
  display: block;
  width: 7.928rem;
  min-width: 7.857142857142857rem;
}

.u8dab7 {
  color: #8497ab;
  font-size: 1.1428571428571428rem;
}

.u1ffe9 {
  display: none;
}

.u942df {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;
}
.u942df .iconfont {
  font-size: 22px;
}
.top_menu_icon {
  margin: 0px 15px !important;
  fill: white;
}
.WhatNew {
  margin-right: 15px;
}
.u6f58a {
  margin-left: 15px;
  height: 48px;
}

.uQOJMWu {
  display: none;
}

.u1337c {
  display: flex;
  width: 21rem;
  background-color: rgb(237, 233, 233);
  padding-left: 0.5rem;
}

.u50ede {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.4285714285714284rem;
  height: 2.4285714285714284rem;
  background: #1290c9;
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  margin-top: 2em;
}

.ud903b {
  padding-top: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.2rem;
  flex: auto;
}

.u7bffa {
  display: flex;
  justify-content: space-between;
}

.uF3Xlzl {
  font-size: 1.4285714285714286rem;
}

.ue08f5 {
  color: rgb(118, 118, 118);
  font-size: 1.1428571428571428rem;
}

.u4defb {
  color: rgb(35, 138, 204);
  font-size: 1.1428571428571428rem;
}

.henggang {
  height: 1px;
  margin: 1px 10px;
  background-color: #dddddd;
}

.uc68vlP {
  margin-right: 16px;
}

.u9qMull {
  font-size: 20px;
  width: 100%;
  display: inline-block;
}

.uiV7d8r {
  margin-right: 1rem;
  margin-left: 1rem;
}

.uE952fV {
  margin-right: 1rem;
  margin-left: 1rem;
}

.uLNvNN4 {
  margin-right: 1rem;
  margin-left: 1rem;
}

.u6srk61 {
  margin-right: 1rem;
  margin-left: 1rem;
}

.udbf23 {
  height: 0.07142857142857142rem;
  margin-right: 0.7142857142857143rem;
  background: #cccccc;
  margin-left: 1rem;
}

.uaeb42 {
  margin-right: 2.142857142857143rem;
  margin-left: 2.142857142857143rem;
}

.u13OR2m {
  margin-right: 1rem;
  margin-left: 1rem;
}

.uuXabem {
  line-height: 5rem;
}
.menu_box_1 path {
  display: flex;
  align-items: center;
  width: 50%;
  margin-bottom: 2rem;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  fill: #1290c9;
}

.uVRU8uU path {
  fill: #fff;
}

.u0fcfc input {
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  border-style: none;
}

.uJuUEnk i {
  color: rgb(255, 255, 255);
}

.uJuUEnk input {
  background-color: rgb(35, 138, 204);
  color: rgb(255, 255, 255);
}

.gaddc3 {
  display: flex;
}

.search_left .head_pro_cas /deep/ .el-input__inner {
  background-color: transparent;
  font-size: 1rem !important;
}

.search_left .head_pro_cas /deep/ .el-input__inner ::input-placeholder {
  color: black;
}

/deep/ .el-input__suffix {
  right: 12px !important;
}

.head_pro_cas /deep/ .el-input__suffix {
  right: 0.2857142857142857rem !important;
}

.head_box {
  width: 100%;
  height: 6.428571428571429rem;
  background: #1290c9;
}

.search2 {
  border: 0.07142857142857142rem solid red !important;
  transition: border-color 0.3s ease-in-out;
}

/* 搜索 */
.head_search {
  width: 67.85714285714286rem;
  height: 3.857142857142857rem;
  background: #ffffff;
  border-radius: 1em;
  border: 0.07142857142857142rem solid #dddddd;
  color: #022955;
  margin-left: 4.428571428571429rem;
}

.search_right {
  flex: 1;
  position: relative;
}

.search_input {
  width: 100%;
  word-wrap: break-word;
  line-height: 2.142857142857143rem;
  outline: none;
  border: none;
  padding: 0 1.4285714285714286rem;
  font-size: 1.14285714rem;
}

.search_btn {
  width: 4.642857142857143rem;
  height: 3.857142857142857rem;
  cursor: pointer;
}

.search_btn img {
  width: 1.7142857142857142rem;
}

/* 选择下拉 */
.search_left {
  width: 190px;
  min-width: 190px;
  height: 30px;
  margin-right: 10px;
  position: relative;
  display: flex;
  align-items: center;
}

.search_left::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 0px;
  width: 1px;
  height: 30px;
  background-color: #dddddd;
}

.search_left /deep/ .el-input__inner {
  border: none;
  font-size: 18px;
}

/deep/ .el-input__inner {
  padding-right: 0px !important;
  padding-left: 10px !important;
}
.search_left_Trade /deep/ .el-input__inner {
  padding-right: 0px !important;
  padding-left: 5px !important;
}

.country_flag {
  display: flex;
  align-items: center;
}
.country_flag_img {
  width: 44px;
  height: 30px;
  margin: 12px 0 12px 5px;
}
.sel_value {
  width: 56px;
  font-size: 12px;
  word-break: break-all;
}
.search_left .el-select {
  position: absolute;
}

.search_left /deep/ .el-select .el-input__inner {
  background-color: transparent;
  font-size: 18px;
  white-space: nowrap;
  padding-left: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search_left.on /deep/ .el-select .el-input__inner {
  padding-left: 52px !important;
  padding-right: 37px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
  color: #022955;
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
  color: #1a2332 !important;
}

.sel_place {
  width: 100%;
  line-height: 3.7142857142857144rem;
  padding-left: 1.4285714285714286rem;
  display: inline-block;
  font-size: 1rem;
}

.el-select-dropdown__wrap {
  max-height: 26.785714285714285rem !important;
}

.el-select-dropdown__list {
  padding: 0.7142857142857143rem 0 !important;
}

.search_sel_container {
  width: 85.71428571428571rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0.07142857142857142rem;
  background-color: #eee;
}

/deep/ .el-popper {
  z-index: 999999 !important;
}

.el-cascader__dropdown {
  z-index: 999999 !important;
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 68.5rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 24.285714285714285rem;
  align-content: flex-start;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 3rem;
  display: flex;
  align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #f5f5f5;
}

.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #1290c9;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 14px;
  margin-right: 10px;
}

.search_sel_container .right .el-select-dropdown__item {
  width: 15.857142857142858rem;
  height: 4rem;
  padding: 0 0.7142857142857143rem;
  margin: 0.3542857142857143rem 0.35714285714285715rem;
  border: 0.07142857142857142rem solid #fff;
  background: #f5f5f5;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #f5f5f5;
  border: 1px solid #1290c9;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 3.857142857142857rem;
  height: 100%;
  margin-right: 0.35714285714285715rem;
}

.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 1.1428571428571428rem;
  line-height: 1;
  margin-bottom: 0.2857142857142857rem;
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/deep/ .el-badge__content--warning {
  background-color: #f56c6c;
  top: 11px !important;
  right: -6px !important;
  width: 20px !important;
  height: 20px !important;
  border-radius: 50%;
  font-size: 12px;
  padding: 0 !important;
  line-height: 18px !important;
}
/deep/ .el-dropdown-menu__item {
  font-size: 20px;
  color: #1a2332;
}
.history_box-head {
  font-size: 1.285714285714286rem;
  width: 100%;
}

.history_box-headborder {
  border-bottom: 0.07142857142857142rem solid #dddddd;
  padding-bottom: 0.7142857142857143rem;
}

.item_title {
  padding: 1.285714285714286rem 0rem;
  border-bottom: 0.07142857142857142rem solid #dddddd;
}

/deep/ .el-popover {
  padding: 1.285714285714286rem !important;
}

.messageimg {
  height: 2.857142857142857rem;
  width: 2.857142857142857rem;
  border-radius: 50%;
}

.item_cont_txt {
  padding: 0.7142857142857143rem;
  border-radius: 0.42857142857142855rem;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  background-color: #f5f5f5;
  margin-top: 1em;
}

.head-text {
  font-family: "Arial Bold";
  font-size: 1.2857142857142858rem !important;
  text-align: left;
  font-style: normal;
  color: #1a2332;
  line-height: 1.4285714285714286rem;
}

.icon-time {
  font-size: 1rem;
  line-height: 1.6428571428571428rem;
  color: #999999;
  margin-top: 0.5714285714285714rem;
}

.message-right {
  margin-left: 1.4285714285714286rem;
}

.history_box_bottom {
  position: absolute;
  bottom: 0rem;
  padding-top: 1rem;
  background: #ffffff;
  width: 100%;
  border-top: 0.07142857142857142rem solid #dddddd;
}

.right-blue {
  margin-top: 0.5rem;
  width: 0.7142857142857143rem;
  height: 0.7142857142857143rem;
  background: #f56c6c;
  border-radius: 50%;
  padding-left: 0.7142857142857143rem;
}

.icontwo {
  margin-right: 0.7142857142857143rem;
}

.postiveaboust {
  position: absolute;
  right: -1rem;
  top: 2.7857142857142856rem;
}

.progress {
  margin-top: 1.4285714285714286rem;
  margin-bottom: 0.7142857142857143rem;
}

.ExpireDate {
  font-size: 14px !important;
  color: #8497ab;
  line-height: 1.1428571428571428rem;
}

.ExpireDate :nth-of-type(1) {
  border-bottom: 0.07142857142857142rem solid #dddddd;
}

.Available {
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  margin-top: 1.1428571428571428rem;
  margin-bottom: 1.4285714285714286rem;
}
/deep/ .el-badge__content {
  height: 16px;
  min-width: 16px;
  border-radius: 50%;
  padding: 0px;
}
/deep/ .el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 25px;
  transform: translateY(-50%) translateX(100%);
  z-index: 100;
}

.history_box {
  height: 21.428571428571427rem;
  overflow-y: auto;
  padding-bottom: 2.857142857142857rem;
}

.u0427c {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-color: #ffffff;
  border-radius: 17px;
  color: #ffffff;
}
.u0427c > div {
  margin-right: 8px;
  font-size: 16px;
}
.u0427c > i {
  font-size: 22px !important;
}

.flex_box {
  position: relative;
}

.right-blue {
  position: absolute;
  right: 0em;
}

.u606de {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  padding: 0.7142857142857143rem 0rem;
  font-size: 1.285714285714286rem;
}

#gfdd55 {
  height: 30px;
  display: flex;
  align-items: center;
}
body:has(.trade_layout) .activecolor {
  color: #009ea7;
}
body:has(.searchCompany_layout) .activecolor {
  color: #1290c9;
}
.marginu6c4a8 {
  margin-left: 1.0714285714285714rem;
}

.sel_box {
  z-index: 9999 !important;
}
.aaaa /deep/ .el-switch__core {
  border-color: rgb(142, 134, 221) !important;
  background-color: rgb(142, 134, 221) !important;
}
.bbbb /deep/ .el-switch__core {
  border-color: #1290c9 !important;
  background-color: #1290c9 !important;
}
.headImg {
  height: 40px;
}

.dataService-input-box {
  background: #fff;
  border-radius: 27px;
  width: 35rem;
  overflow: hidden;
}
.dataService-input-box.flex_center_start {
  justify-content: inherit;
}
.dataService-input {
  width: 32.715rem;
  height: 54px;
  background: #ffffff;
  border-radius: 27px;
}
.dataService-input /deep/ .el-input {
  height: 100%;
}
.dataService-input /deep/ .el-input__inner {
  border: 0;
  padding: 0 20px !important;
  border-radius: 27px;
}
.dataService-input /deep/ .el-input__inner::placeholder {
  color: #9aa2a1;
}
.dataService-input /deep/ .el-input__suffix {
  /* right: 0px !important; */
  display: none;
}
.dataService-input-box .search-iconstyle {
  color: #b98b73;
  font-size: 30px;
  margin: 0 16px 0 0;
}
.dataService-top {
  display: flex;
  margin-right: 68px;
}
.dataService-top-link {
  font-family: Arial, Arial;
  font-weight: 400;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 22px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-right: 46px;
  cursor: pointer;
  position: relative;
}
.dataService-top-link:last-of-type {
  margin-right: 0;
}
.dataService-top-link .active-line {
  width: 100%;
  height: 2px;
  background: #ffffff;
  border-radius: 2px;
  position: absolute;
  left: 0;
  bottom: -6px;
  display: none;
}
.dataService-top-link.active {
  color: #fff;
}
.dataService-top-link.active .active-line {
  display: block;
}
.menu-icon:hover .menu-round-item:first-child {
  width: 100%;
  height: 4px;
}
.menu-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 28px;
  margin-right: 40px;
  cursor: pointer;
}
.menu-round-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-round-con .menu-round-item {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
  box-shadow: none;
}
.menu-round-item {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
}
.menu-icon:hover .menu-round-item:first-child {
  width: 100%;
  height: 4px;
}
.menu-icon:hover .menu-round-item:nth-last-child(-n + 2) {
  width: 0px;
}
.header_logo {
  height: 28px;
}
.u942df .iconfont.icon-zuyuan {
  font-size: 26px;
}
.u942df .iconfont.icon-wenhao,
.u942df .iconfont.icon-lingdang222 {
  font-size: 22px;
}
.u942df .iconfont.icon-icon-test {
  font-size: 30px;
}
.u942df .iconfont.icon-yuyan-02 {
  font-size: 27px;
}
.icon_ow {
  width: 26px;
  height: 26px;
}
.icon_group {
  font-size: 26px;
}
.head_swi_keyword {
  position: relative;
  margin-right: 20px;
}
.head_swi_keyword /deep/ .el-switch {
  height: 40px;
  line-height: 40px;
}
.head_swi_keyword /deep/ .el-switch__core {
  width: 100px !important;
  height: 40px;
  border-radius: 20px;
  border: none;
}
.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
  background: #1290c9;
}
.head_swi_keyword /deep/ .el-switch__core:after {
  top: 2px;
  left: 1px;
  width: 36px;
  height: 36px;
  background: #ffffff;
}
.head_swi_keyword /deep/ .el-switch.is-checked + .switch_txt {
  top: 50%;
  transform: translate(-80%, -50%);
  left: 50%;
}
.switch_txt {
  position: absolute;
  left: 40px;
  top: 5px;
  font-size: 14px;
  color: #ffffff;
  line-height: 14px;
}
.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
  margin-left: 0 !important;
  left: 63px !important;
}
.icon_fangdajing {
  width: 30px;
  height: 30px;
}
.active.list-popper-con-item,
.list-popper-con-item:hover {
  color: #1290c9;
}
.active.list-popper-con-item,
.list-popper-con-item:hover {
  background: #f5f5f5;
}
.list-popper-con {
  padding: 10px 0;
}
.list-popper-con-item {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}
.list-popper-con-item i {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-right: 16px;
  font-size: 26px;
  color: #1a2332;
}
.list-popper-con-item .icon-shujuku-hover {
  font-size: 21px;
}
.list-popper-con-item .icon-lingdang {
  font-size: 23px;
}
.list-popper-con-item .icon-tuichu {
  font-size: 30px;
  padding-top: 3px;
}
.page-top-header-right-icon {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  font-size: 22px;
  color: var(--font_color);
  cursor: pointer;
  z-index: 2;
}
.news-popper-con-top {
  padding: 20px 0 0 0;
}
.news-popper-con-top-title {
  display: flex;
  align-items: center;
  height: 24px;
  margin-bottom: 10px;
  padding: 0 20px;
}
.news-popper-con-top-title-txt {
  font-size: 20px;
  color: #1a2332;
}
.news-popper-con-top-title-num {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-left: 4px;
  font-size: 12px;
  color: #ffffff;
  background: #f56c6c;
  border-radius: 50%;
}
.news-popper-con-top-list {
  width: 100%;
  max-height: 21.8rem;
  padding-left: 20px;
  overflow-y: auto;
}
.news-popper-con-top-list-con {
  width: 390px;
}
.news-popper-con-no {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}
.news-popper-con-no img {
  width: 204px;
  height: 204px;
  margin-bottom: 10px;
}
.news-popper-con-no span {
  font-size: 18px;
  color: #999999;
}
.news-popper-con-top-list-item {
  display: flex;
  padding: 20px 0;
  border-top: 1px solid #dddddd;
}
.news-popper-con-top-list-item-logo {
  display: flex;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.news-popper-con-top-list-item-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.news-popper-con-top-list-item-title-txt {
  line-height: 20px;
  font-family: "Arial Bold";
  font-size: 18px;
  color: #1a2332;
}
.news-popper-con-top-list-item-title-bg {
  width: 10px;
  height: 10px;
  margin-top: 5px;
  margin-left: 6px;
  background: #f56c6c;
  border-radius: 50%;
}
.news-popper-con-top-list-item-date {
  line-height: 16px;
  font-size: 14px;
  color: #999999;
}
.news-popper-con-top-list-item-con {
  flex-grow: 1;
}
.news-popper-con-top-list-item-content {
  line-height: 20px;
  padding: 10px;
  margin-top: 14px;
  font-size: 16px;
  color: #1a2332;
  background: #f5f5f5;
  border-radius: 6px;
  display: none;
}
.news-popper-con-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 66px;
  padding: 0 20px;
  background: #ffffff;
  border-top: 1px solid #dddddd;
}
.notify-clear-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  min-width: 200px !important;
  height: 40px;
  min-height: 40px !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #1a2332;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dddddd;
}
.notify-clear-btn.is-disabled {
  color: #999999;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.notify-clear-btn >>> span {
  display: flex;
}
.notify-clear-btn i {
  display: flex;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  font-size: 18px;
}
.notify-view-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  min-width: 120px !important;
  height: 40px;
  min-height: 40px !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #ffffff;
  border-radius: 10px;
  border: 1px solid #dddddd;
  background: #1290c9;
}
.credit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 120px !important;
  height: 40px;
  min-height: 40px !important;
  padding: 0 !important;
  font-size: 18px !important;
  color: #ffffff;
  border-radius: 10px;
  background: #1290c9;
}
.popper-con-user {
  display: flex;
}
.point-popper-con .popper-con-user {
  margin-bottom: 24px;
}
.people-popper-con .popper-con-user {
  padding: 20px 20px 14px 20px;
}
.popper-con-user-left {
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: 22px;
}
.popper-con-user-left-people {
  display: flex;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  border-radius: 50%;
}
.popper-con-user-left-people .popper-con-user-left-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #f5f5f5;
}
.popper-con-user-round {
  padding: 0 5px;
  font-size: 36px;
  color: #a2a9b0;
  white-space: nowrap;
  background: #f5f5f5;
}
.popper-con-user-round-text {
  display: block;
  width: 100%;
  line-height: 50px;
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;
}
.page-top-header-right-people {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f5f5f5;
  cursor: pointer;
  z-index: 2;
}
.page-top-header-right-img {
  width: 48px;
  height: 48px;
  cursor: pointer;
  border-radius: 50%;
}
.page-top-header-right-people.popper-con-user-round {
  font-size: 28px;
}
.page-top-header-right-login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  cursor: pointer;
  border-color: var(--font_color);
}
.page-top-header-right-login > div {
  margin-right: 8px;
  font-size: 16px;
  color: var(--font_color);
}
.page-top-header-right-login > i {
  font-size: 22px;
  color: var(--font_color);
}
.popper-con-user-left-vip {
  position: absolute;
  bottom: 0;
  left: 14px;
  display: flex;
  width: 58px;
  height: 22px;
}
.popper-con-user-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
}
.popper-con-user-right-name {
  line-height: 24px;
  margin-bottom: 4px;
  font-size: 20px;
  color: #1a2332;
}
.popper-con-user-right-type {
  line-height: 20px;
  font-size: 16px;
  color: #8497ab;
}
.golden .popper-con-user-right-type {
  color: #bc8553;
}
.silver .popper-con-user-right-type {
  color: #666666;
}
.point-popper-con-lock {
  padding-bottom: 10px;
  margin-bottom: 16px;
  border-bottom: 1px solid #dddddd;
}
.point-popper-con-lock-progress {
  margin-bottom: 4px;
}
.point-popper-con-lock-progress >>> .el-progress-bar__outer {
  height: 10px !important;
}
.point-popper-con-lock-desc {
  line-height: 18px;
  font-size: 14px;
  color: #8497ab;
}
.point-popper-con-point {
  display: flex;
  margin-bottom: 20px;
}
.point-popper-con-point-icon {
  display: flex;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.point-popper-con-point-desc {
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  color: #1a2332;
}
.people-popper-con-line {
  width: 300px;
  height: 1px;
  margin: 0 auto;
  background: #dddddd;
}
.people-popper-con-signout {
  padding: 15px 0;
}
.list-popper-con-item-img {
  display: flex;
  width: 30px;
  height: 20px;
  margin-right: 10px;
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.country-dropdown,
.trade-dropdown {
  position: relative;
  width: 210px;
  min-width: 210px;
  border-radius: 27px 0 0 27px;
  margin-right: 10px;
}
.country-dropdown::after,
.trade-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}
.trade-item-con:hover,
.trade-item-con.activeTrade {
  background: #f5f5f5;
  color: #009ea7;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 14px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
  color: #1a2332;
}

.select-country-con i {
  font-size: 16px;
  color: #1a2332;
  transition: all 0.3s;
}

.country-arrow {
  transform: rotate(180deg);
}

.select-country-img {
  width: 34px;
  height: 20px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 18px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.leads_country-popper,
.country-popper {
  position: absolute;
  top: 68px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}
.country-popper {
  width: 1000px;
  left: 0;
}
.leads_country-popper {
  width: 700px;
  left: 210;
}
.leads_country-show-popper,
.country-show-popper {
  width: 1178px;
  height: 378px;
  opacity: 1;
  z-index: 2001;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}

.trade-popper {
  position: absolute;
  top: 58px;
  left: 0;
  width: 200px;
  height: auto;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.trade-show-popper {
  opacity: 1;
  z-index: 2000;
  pointer-events: all;
  transform: rotateX(0deg);
}

.trade-item-con {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}

.trade-item-con:not(:last-child) {
  margin-bottom: 4px;
}
.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.country-popper-arrow {
  left: 60px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}

.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}

.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}
.leads_state-con,
.country-popper-con .state-con {
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}
.country-popper-con .state-con {
  width: 220px;
}
.leads_state-con {
  width: 100px;
}
.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  cursor: pointer;
}

.country-popper-con .country-state-item:not(:last-child) {
  margin-bottom: 8px;
}
.leads_country-name,
.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}
.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
}
.country-popper-con .country-state-item:hover .country-name,
.country-popper-con .country-state-item.activeState .country-name {
  color: #1290c9;
}
.leadsActiveState,
.leads_country-popper .pro_item:hover,
.leads_country-popper .country-state-item:hover .leads_country-name,
.leadsActiveState .leads_country-name {
  color: #8e86dd;
  background: #f5f5f5;
}
.country-popper-con .country-countryCount {
  width: 30px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}
.leads_state-country-con,
.country-popper-con .state-country-con {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}
.country-popper-con .state-country-con {
  width: 953px;
}
.leads_state-country-con {
  width: 880px;
}
.country-popper-con .state-country-item {
  width: 222px;
  height: 56px;
  padding: 8px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  cursor: pointer;
}

.country-popper-con .state-country-item-con {
  display: flex;
  align-items: center;
  justify-content: start;
}

.country-popper-con .state-country-item:hover,
.country-popper-con .state-country-item.activeCountry {
  border-color: #1290c9;
}
.country-popper-con .state-country-item:not(:nth-child(4n)) {
  margin-right: 10px;
}

.country-popper-con .state-country-item img {
  width: 56px;
  height: 34px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}

.country-popper-con .state-country-name {
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}
/* 获客 */
.select-country-name {
  line-height: 20px;
  font-size: 18px;
}
.search-country-input {
  padding: 0 10px;
}
.search-country-input >>> .el-input__inner {
  line-height: 54px;
  font-size: 16px;
  padding: 0 !important;
  color: #1a2332;
  border: none !important;
  border-radius: 0;
}
#g1032d .icon-search {
  font-size: 24px;
  color: #1a2332;
}
.search_type {
  width: 188px;
  height: 70px;
  background: #ffffff;
  border-radius: 35px 0 0 35px;
  padding: 20px 0 20px 20px;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  position: relative;
}

.search_type span {
  flex: 1;
  text-align: left;
}

.search_type i {
  width: 30px;
}

.search_type_select {
  position: absolute;
  top: 74px;
  left: 0;
  width: 296px;
  height: auto;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.search_type_select_show {
  opacity: 1;
  z-index: 999;
  pointer-events: all;
  transform: rotateX(0deg);
}

.search_type_select_list {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}

.search_type_select_list.active {
  background: #f5f5f5;
  color: #8e86dd;
}
.autocomplete-item {
  margin: 0;
  line-height: 34px;
  cursor: pointer;
  font-size: 14px;
  list-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.leads_country-popper .pro_item {
  width: 100%;
  line-height: 34px;
  cursor: pointer;
  color: #1a2332;
  font-size: 16px;
  list-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 1920px) {
  .dataService-input-box,
  .dataService-input,
  .dataService-input /deep/ .el-input__inner {
    border-radius: 20px;
  }
  .layout_header_cont {
    padding: 0 30px 0 22px;
  }
  .dataService-top-link {
    font-size: 16px;
    margin-right: 55px;
    line-height: 14px;
  }
  /* .dataService-top {
    margin-right: 128px;
  } */
  .dataService-input {
    height: 36px !important;
    line-height: 36px;
  }
  .dataService-input.el-cascader .el-input {
    height: 36px !important;
  }
  .dataService-input-box .search-iconstyle {
    font-size: 20px;
  }
  .top_menu_icon {
    margin: 0px 11px !important;
  }
  .WhatNew {
    margin-right: 11px;
  }
  .u6f58a {
    margin-left: 11px;
    height: 32px;
  }
  .u942df .iconfont {
    font-size: 20px;
  }
  .u942df .iconfont.icon-zuyuan {
    font-size: 23px;
  }
  .u942df .iconfont.icon-icon-test {
    font-size: 24px;
  }
  .u942df .iconfont.icon-yuyan-02 {
    font-size: 22px;
  }
  .menu-icon {
    width: 22px;
    height: 22px;
    margin-right: 26px;
  }
  .menu-round-con .menu-round-item {
    width: 4px;
    height: 4px;
    border-radius: 2px;
  }
  .u52ab1 {
    width: 700px;
    padding: 8px 15px 8px 0px;
    height: 40px;
    border-radius: 20px;
    top: 13px;
  }
  .u942df .iconfont.icon-wenhao {
    font-size: 20px;
  }
  .u942df .iconfont.icon-lingdang222 {
    font-size: 18px;
  }
  .header_logo {
    height: 22px;
  }
  .u9qMull {
    font-size: 18px;
  }
  .uc68vlP {
    margin-right: 12px;
  }
  .u0fcfc /deep/ .el-input__inner {
    font-size: 14px !important;
  }
  .search_left {
    width: 145px;
    min-width: 145px;
  }
  .search_left::after {
    top: 4px;
    height: 22px;
  }
  .country_flag_img {
    width: 30px;
    height: 20px;
    margin: 9px 0 9px 4px;
  }

  .sel_value {
    width: 42px;
    font-size: 12px;
  }
  /deep/ .el-badge__content.is-fixed {
    right: 20px;
  }
  .icon_ow {
    width: 24px;
    height: 24px;
  }
  .icon_group {
    font-size: 21px;
  }
  .search_left.on /deep/ .el-select .el-input__inner {
    padding-left: 36px !important;
    padding-right: 31px !important;
  }
  /deep/ .el-input__suffix {
    right: 8px !important;
  }
  .head_swi_keyword {
    margin-right: 15px;
  }
  .head_swi_keyword /deep/ .el-switch {
    height: 32px;
    line-height: 32px;
  }
  .head_swi_keyword /deep/ .el-switch__core {
    width: 90px !important;
    height: 32px;
    border-radius: 16px;
  }
  .head_swi_keyword /deep/ .el-switch__core:after {
    top: 1px;
    left: 1px;
    width: 30px;
    height: 30px;
  }
  .head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
    left: 59px !important;
  }
  .switch_txt {
    left: 40px;
    top: 5px;
    font-size: 12px;
    line-height: 12px;
  }
  #gfdd55 {
    height: 26px;
  }
  .icon_fangdajing {
    width: 26px;
    height: 26px;
  }
  .list-popper-con {
    padding: 6px 0;
  }
  .list-popper-con-item {
    height: 35px;
    padding: 0 14px;
    font-size: 16px;
  }
  .list-popper-con-item i {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    font-size: 22px;
  }
  .list-popper-con-item .icon-shujuku-hover {
    font-size: 17px;
  }
  .list-popper-con-item .icon-lingdang {
    font-size: 19px;
  }
  .list-popper-con-item .icon-tuichu {
    font-size: 26px;
    padding-top: 2px;
  }
  .page-top-header-right-icon {
    width: 18px;
    height: 18px;
    font-size: 18px;
  }
  .news-popper-con-top {
    padding: 14px 0 0 0;
  }
  .news-popper-con-top-title {
    height: 18px;
    margin-bottom: 6px;
    padding: 0 14px;
  }
  .news-popper-con-top-title-txt {
    font-size: 16px;
  }
  .news-popper-con-top-title-num {
    width: 16px;
    height: 16px;
    margin-left: 3px;
  }
  .news-popper-con-top-list {
    max-height: 21.8rem;
    /* min-height: 252px; */
    padding-left: 14px;
  }
  .news-popper-con-top-list-con {
    width: 270px;
  }
  .news-popper-con-no {
    padding-top: 26px;
  }
  .news-popper-con-no img {
    width: 140px;
    height: 140px;
    margin-bottom: 6px;
  }
  .news-popper-con-no span {
    font-size: 14px;
  }
  .news-popper-con-top-list-item {
    padding: 14px 0;
  }
  .news-popper-con-top-list-item-logo {
    width: 28px;
    height: 28px;
    margin-right: 7px;
  }
  .news-popper-con-top-list-item-title {
    margin-bottom: 5px;
  }
  .news-popper-con-top-list-item-title-txt {
    line-height: 16px;
    font-size: 14px;
  }
  .news-popper-con-top-list-item-title-bg {
    width: 7px;
    height: 7px;
    margin-top: 3px;
    margin-left: 4px;
  }
  .news-popper-con-top-list-item-date {
    line-height: 14px;
    margin-bottom: 10px;
    font-size: 12px;
  }
  .news-popper-con-top-list-item-content {
    line-height: 14px;
    padding: 6px;
    font-size: 12px;
    border-radius: 4px;
  }
  .news-popper-con-bottom {
    height: 44px;
    padding: 0 14px;
  }
  .notify-clear-btn {
    width: 140px;
    min-width: 140px !important;
    height: 28px;
    min-height: 28px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }
  .notify-clear-btn i {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    font-size: 14px;
  }
  .notify-view-btn {
    width: 80px;
    min-width: 80px !important;
    height: 28px;
    min-height: 28px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }
  .credit-btn {
    min-width: 80px !important;
    height: 28px;
    min-height: 28px !important;
    font-size: 14px !important;
    border-radius: 6px;
  }
  .point-popper-con .popper-con-user {
    margin-bottom: 16px;
  }
  .people-popper-con .popper-con-user {
    padding: 14px 14px 10px 14px;
  }
  .popper-con-user-left {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }
  .popper-con-user-round {
    padding: 0 3px;
    font-size: 24px;
  }
  .popper-con-user-round-text {
    line-height: 40px;
  }
  .page-top-header-right-people.popper-con-user-round {
    font-size: 20px;
  }
  .page-top-header-right-people .popper-con-user-round-text {
    line-height: 32px;
  }
  .popper-con-user-left-vip {
    left: 9px;
    width: 38px;
    height: 15px;
  }
  .popper-con-user-right {
    height: 40px;
  }
  .popper-con-user-right-name {
    line-height: 16px;
    margin-bottom: 3px;
    font-size: 14px;
  }
  .popper-con-user-right-type {
    line-height: 14px;
    font-size: 12px;
  }
  .point-popper-con-lock {
    padding-bottom: 6px;
    margin-bottom: 10px;
  }
  .point-popper-con-lock-progress {
    margin-bottom: 3px;
  }
  .point-popper-con-lock-progress >>> .el-progress-bar__outer {
    height: 7px !important;
  }
  .point-popper-con-lock-desc {
    line-height: 14px;
    font-size: 12px;
  }
  .point-popper-con-point {
    margin-bottom: 14px;
  }
  .point-popper-con-point-icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .point-popper-con-point-desc {
    height: 16px;
    line-height: 16px;
    font-size: 14px;
  }
  .people-popper-con-line {
    width: 200px;
  }
  .people-popper-con-signout {
    padding: 10px 0;
  }
  .list-popper-con-item-img {
    width: 20px;
    height: 14px;
    margin-right: 6px;
  }
  .u5a174 {
    height: 22px;
    width: 240px;
  }
  .ub36bc {
    height: 22px;
  }
  .search_left_Trade /deep/ .el-input__inner {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  .u0427c {
    width: 82px;
    height: 30px;
    border-radius: 15px;
  }
  .u0427c > div {
    margin-right: 5px;
    font-size: 14px;
  }
  .u0427c > i {
    font-size: 18px !important;
  }
  .country-dropdown,
  .trade-dropdown {
    width: 160px;
    min-width: 160px;
    border-radius: 20px 0 0 20px;
  }

  .country-dropdown::after,
  .trade-dropdown::after {
    height: 22px;
  }

  .select-country-con {
    padding: 0 10px 0 15px;
  }

  .select-country-con .country-placeholder {
    font-size: 14px;
  }

  .select-country-img {
    width: 22px;
    height: 14px;
    margin-right: 4px;
  }

  .select-country-name {
    margin-right: 2px;
    line-height: 16px;
    font-size: 14px;
  }

  .trade-dropdown .select-country-name {
    font-size: 14px;
  }
  .leads_country-popper,
  .country-popper {
    top: 45px;
    height: 200px;
    padding: 10px 3px 10px 0;
    border-radius: 4px;
  }
  .country-popper {
    width: 750px;
  }
  .leads_country-popper {
    width: 600px;
    left: 160px;
  }

  .country-show-popper {
    width: 850px;
    height: 264px;
  }
  .leads_country-show-popper {
    width: 600px;
    height: 264px;
  }
  .trade-popper {
    top: 43px;
    width: 160px;
    padding: 8px 0;
    border-radius: 4px;
  }

  .country-popper-arrow {
    left: 35px;
    top: -6px;
    border-width: 6px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }

  .country-popper-arrow::after {
    border-width: 8px;
  }

  .leads_state-con {
    width: 80px;
    height: 100%;
  }
  .country-popper-con .state-con {
    width: 218px;
    height: 100%;
  }

  .country-popper-con .country-state-item {
    height: 40px;
    padding: 0 14px;
  }

  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 0px;
  }
  .leads_country-name,
  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }

  .country-popper-con .country-countryCount {
    flex-shrink: 0;
    width: 20px;
    font-size: 12px;
  }

  .country-popper-con .state-country-con {
    width: 640px;
    padding-left: 10px;
  }
  .leads_state-country-con {
    width: 516px;
    padding-left: 10px;
  }
  .country-popper-con .state-country-item {
    width: 148px;
    height: 40px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }

  .country-popper-con .state-country-item:not(:nth-child(4n)) {
    margin-right: 6px;
  }

  .country-popper-con .state-country-item img {
    width: 38px;
    height: 22px;
    margin-right: 4px;
  }

  .country-popper-con .state-country-name {
    line-height: 14px;
    margin-bottom: 2px;
    font-size: 14px;
  }

  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }

  .trade-item-con {
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    font-size: 16px;
  }

  .trade-item-con:not(:last-child) {
    margin-bottom: 2px;
  }
  .page-top-header-right-people {
    width: 32px;
    height: 32px;
  }
  .page-top-header-right-img {
    width: 32px;
    height: 32px;
  }
  .page-top-header-right-login {
    width: 82px;
    height: 30px;
    border-radius: 15px;
  }
  .page-top-header-right-login > div {
    margin-right: 5px;
    font-size: 14px;
  }
  .page-top-header-right-login > i {
    font-size: 18px;
  }

  /* // 获客搜索 */
  .search-country-input >>> .el-input__inner {
    line-height: 36px;
    font-size: 14px;
  }
  #g1032d .icon-search {
    font-size: 22px;
  }
  .select-country-name {
    font-size: 14px;
    line-height: 18px;
  }
  .search_type_select {
    top: 43px;
    padding: 8px 0;
    border-radius: 4px;
  }
  .search_type_select_list {
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    font-size: 16px;
    margin-bottom: 2px;
  }
  .autocomplete-item {
    font-size: 14px;
  }
  .leads_country-popper .pro_item {
    font-size: 14px;
  }
}
@media (max-width: 1700px) {
  .dataService-top {
    margin-right: 48px;
  }
  .dataService-top-link {
    margin-right: 20px;
  }
}
@media (max-width: 1439px) {
  .dataService-top {
    margin-right: 28px;
  }
  .dataService-top-link {
    margin-right: 20px;
    font-size: 14px;
  }
  .layout_header_cont {
    padding: 0 20px 0 26px;
  }
  /deep/ .el-dropdown-menu__item {
    font-size: 16px;
  }
  .u9qMull {
    font-size: 16px;
  }
  .uc68vlP {
    margin-right: 10px;
  }

  .sel_value {
    width: 38px;
    font-size: 12px;
  }
  .u52ab1 {
    border-radius: 20px;
    top: 9px;
  }
}
</style>
<style>
.search_left_Trade .el-select-dropdown__item.selected.hover,
.search_left_Trade .el-select-dropdown__item.selected {
  color: #009ea7;
}
</style>
